import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

import { firebase } from 'utils/constant'

const config = {
  apiKey: firebase.apiKey,
  authDomain: firebase.authDomain,
  databaseURL: firebase.databaseURL,
  projectId: firebase.projectId,
  storageBucket: firebase.storageBucket,
  messagingSenderId: firebase.messagingSenderId,
  appId: firebase.appId,
  measurementId: firebase.measurementId,
}

const firebaseApp = initializeApp(config)
export default firebaseApp

export const auth = getAuth(firebaseApp)
export const firestore = getFirestore(firebaseApp)
export const functions = getFunctions(firebaseApp)
